{
  "search-join-attendee-submit-btn": "LISTO",
  "go-to-package-btn": "Opciones de compra",
  "done-exit-btn": "Listo (Salir del kiosco)",
  "title-select-package": "Selecciona un paquete",
  "title-suggest-a-product": "¿Te gustaría agregar otro producto a tu pedido?",
  "title-choose-a-product": "Elige un producto para agregar a tu pedido",
  "store-title": "Selecciona el producto que deseas comprar",
  "title-shopping-cart": "Carrito de compras",
  "select-images-notice-message": "Selecciona las imágenes que deseas imprimir.",
  "select-images-notice-ok": "OK",
  "confirm-change-img-btn": "OK, usar esta imagen",
  "select-image-title": "Foto de perfil OCCO",
  "welcome-title": "Álbum de fotos",
  "welcome-event-list-label": "Lista de eventos:",
  "welcome-item-count-label": "Cantidad de artículos:",
  "select-image-selection-title": "Selecciona {{count}} imagen(es)",
  "select-image-step-label": "Paso {{currentStep}} de {{totalSteps}}",
  "select-image-for-product-text": "para \"{{title}}\"",
  "select-image-next-btn": "Siguiente ({{selectedCount}}/{{requiredCount}})",
  "select-image-clear-btn": "Limpiar",
  "select-image-no-photos-message": "No hay fotos disponibles",
  "select-image-no-uid-message": "Ups, hubo un problema al localizar tu cuenta. Inténtalo de nuevo.",
  "select-image-unlock-notice-message": "Selecciona las imágenes que deseas desbloquear.",
  "select-image-print-or-unlock-notice-message": "Selecciona las imágenes que deseas imprimir o desbloquear.",
  "select-image-addon-selection-title": "Selecciona imágenes",
  "select-image-addon-done-count-btn": "Listo ({{count}})",
  "select-image-no-compatible-image-message": "No se encontró una imagen compatible",
  "select-image-photo-limit-message": "Selecciona {{count}} imagen(es) que deseas imprimir.",
  "welcome-gallery-title": "Mi álbum",
  "welcome-select-images-of-yourself-title": "Selecciona todas las imágenes en las que apareces",
  "welcome-select-found-images-title": "Selecciona las fotos que deseas agregar a tu galería",
  "welcome-back-to-gallery-btn": "Volver al álbum",
  "checkout-subtotal-label": "Subtotal:",
  "checkout-taxes-label": "Impuestos:",
  "checkout-total-label": "Total:",
  "checkout-btn": "Pagar",
  "checkout-add-on-btn": "+ AGREGAR EXTRA",
  "checkout-add-product-btn": "Agregar producto",
  "checkout-empty-cart-message": "El carrito está vacío",
  "checkout-promo-code-placeholder": "solo para personal",
  "checkout-invalid-promo-code-message": "¡Código promocional inválido o vencido!",
  "checkout-discount-label": "Descuento: {{title}}",
  "checkout-receipt-title": "Recibo",
  "checkout-receipt-product-label": "Producto",
  "checkout-receipt-unit-price-label": "Precio unitario",
  "checkout-receipt-qty-label": "Cant.",
  "checkout-receipt-amount-label": "Importe",
  "checkout-digital-package-upsell-message": "¿Te gustaría agregar un<br>paquete digital a tu<br>carrito de compras y obtener acceso<br>a todos tus archivos digitales?",
  "photo-plus-pass-required-message": "Parece que todavía no tienes un Photo+ Pass.<br><br>Consíguelo ahora para acceder al contenido en alta resolución.",
  "photo-plus-valid-ticket-required-message": "Parece que todavía no tienes un boleto válido para tu visita al parque. Vincula tu boleto para disfrutar de nuestra experiencia Photo+.",
  "photo-plus-visit-availability-message": "Tu experiencia Photo+ está disponible durante tu visita a Genting SkyWorlds.",
  "checkout-other-products-upsell-message": "¿Te gustaría agregar una impresión a tu paquete digital?",
  "checkout-delete-restriction-message": "Debes mantener al menos un paquete en tu carrito de compras si deseas comprar extras. Si necesitas cambiar el paquete, primero elimina todos los extras de tu carrito.",
  "checkout-digital-package-duplicate-message": "Ya tienes un paquete de acceso digital en tu carrito de compras.<br>No se puede agregar un nuevo paquete hasta que elimines o compres el actual.",
  "welcome-print-modal-title": "Imprimir",
  "welcome-print-modal-text": "Tus fotos se imprimirán y se entregarán a tu organizador del evento.",
  "cancel-btn": "Cancelar",
  "welcome-preview-modal-title": "Vista previa",
  "close-btn": "Cerrar",
  "ok-btn": "OK",
  "back-btn": "Atrás",
  "info-title": "Información",
  "apply-btn": "Aplicar",
  "clear-btn": "Limpiar",
  "yes-btn": "Sí",
  "no-btn": "No",
  "change-image-btn": "Cambiar imagen",
  "done-btn": "Listo",
  "skip-btn": "Omitir",
  "refresh-btn": "Actualizar",
  "exit-btn": "Salir",
  "unsupported-picture-format-message": "Formato de imagen inválido o no compatible",
  "welcome-alert-modal-title": "Título del modal",
  "welcome-alert-modal-body-text": "El texto del modal va aquí.",
  "welcome-alert-save-btn": "Guardar cambios",
  "welcome-passcodes-modal-title": "Generar códigos de acceso",
  "welcome-passcodes-events-label": "Selecciona los eventos para los que deseas generar códigos de acceso:",
  "welcome-passcodes-email-label": "Correo electrónico para recibir los códigos de acceso en formato XLS:",
  "welcome-passcodes-count-label": "Número de códigos de acceso a generar:",
  "welcome-passcodes-count-help": "Un número entre 1 y 200,000",
  "welcome-passcodes-prepaid-label": "¿Los titulares de esas tarjetas serán considerados prepagados/VIP?:",
  "welcome-passcodes-expiry-label": "El acceso al kiosco público debe vencer (minutos) (0 para desactivar esta opción):",
  "welcome-passcodes-url-prefix-label": "Prefijo de URL de acceso al álbum (ej. https://domain-name.com):",
  "welcome-passcodes-generate-btn": "Generar",
  "sharing-modal-title": "Compartir imágenes",
  "sharing-tab-email": "Correo",
  "sharing-tab-sms": "SMS",
  "sharing-email-name-placeholder": "Nombre completo",
  "sharing-email-placeholder": "Correo electrónico válido",
  "sharing-email-help-text": "Separa varias direcciones de correo con punto y coma, coma, espacio o la tecla Enter.",
  "sharing-contact-phone-placeholder": "Número de teléfono",
  "sharing-company-placeholder": "Empresa/Institución",
  "sharing-sms-name-placeholder": "Nombre completo",
  "sharing-sms-phone-placeholder": "Número de teléfono válido",
  "sharing-privacy-link": "Política de privacidad",
  "sharing-privacy-prefix": "Tu privacidad es muy importante para nosotros, por favor lee nuestra",
  "welcome-delete-modal-title": "Eliminar",
  "welcome-delete-modal-body": "¿Estás seguro de que deseas eliminar esta foto de tu álbum?",
  "welcome-delete-photo-confirmation-message": "¿De verdad estás seguro de que deseas eliminar esta imagen de tu álbum?",
  "welcome-delete-photo-keep-btn": "¡Conservar esta imagen!",
  "welcome-delete-photo-delete-btn": "Eliminar esta imagen de mi álbum",
  "welcome-delete-reason-not-mine-btn": "Sí. Esta no es mi foto",
  "welcome-delete-confirm-btn": "Eliminar",
  "welcome-selfie-modal-title": "Buscar mis imágenes por rostro",
  "welcome-selfie-match-found-title": "¡Creemos que te encontramos!",
  "welcome-selfie-match-found-confirm-message": "Toca tus imágenes para confirmar.",
  "welcome-selfie-capture-btn": "Haz clic aquí",
  "welcome-delete-reason-dont-want-btn": "Sí. La foto es mía, pero no la quiero",
  "welcome-print-copy-count-label": "Selecciona la cantidad de copias impresas",
  "catalog-select-product-package-title": "Selecciona el paquete del producto",
  "freedompay-offline-request-title": "Ingresa el ID de solicitud de transacción offline",
  "square-reader-access-token-title": "Ingresa el token de acceso de Square",
  "square-reader-pairing-code-title": "Usa este código para iniciar sesión en tu nuevo lector Square y haz clic en OK cuando termines.",
  "square-reader-still-unpaired-text": "Este dispositivo aún no está emparejado; usa el código para iniciar sesión en tu nuevo lector Square.",
  "square-reader-security-note-title": "Toma nota de las siguientes dos claves, ya que no se guardarán por razones de seguridad",
  "storicard-invalid-code-text": "Código de StoriCard inválido.",
  "header-menu-user-id-link": "UserID:",
  "countdown-time-up-text": "¡Se acabó el tiempo!",
  "welcome-find-more-images-btn": "Buscar más imágenes",
  "welcome-select-images-btn": "Seleccionar imágenes",
  "welcome-selected-images-next-btn": "Soy yo en estas {{count}} imágenes, Siguiente >",
  "welcome-invalid-attendee-id-message": "ID de asistente inválido.",
  "welcome-kiosk-time-expired-message": "Lo sentimos, el tiempo del kiosco público ha expirado",
  "welcome-grouping-error-message": "No se permite agrupar cuentas creadas hace más de 3 días.",
  "confirm-btn": "Confirmar",
  "approved-btn": "Aprobado",
  "checkout-confirm-purchase-title": "Por favor confirma tu compra",
  "checkout-confirm-purchase-short-title": "Confirmar compra",
  "checkout-digital-access-summary": "Acceso a todas tus imágenes digitales tomadas hoy",
  "checkout-and-text": "y",
  "checkout-print-count-summary": "{{count}} impresión(es)",
  "checkout-digitals-copy-message": "¿Te gustaría tener una copia de tus archivos digitales?<br> Por si pierdes tu tarjeta.",
  "checkout-email-placeholder": "Tu correo electrónico",
  "checkout-email-or-phone-placeholder": "Tu correo electrónico o número de teléfono de EE. UU.",
  "checkout-sms-agreement-label": "Acepto recibir mensajes de notificación de Storibox en el número de teléfono proporcionado arriba. Entiendo que recibiré mensajes SMS con actualizaciones y enlaces a mis imágenes. Pueden aplicarse tarifas de datos y mensajería. Responde STOP para cancelar.",
  "checkout-name-placeholder": "Tu nombre",
  "checkout-cancel-transaction-btn": "Cancelar transacción",
  "checkout-employee-authorization-title": "Se requiere autorización del empleado",
  "checkout-scan-employee-card-prefix": "Escanea tu tarjeta de empleado cuando la transacción de",
  "checkout-transaction-complete-suffix": "esté completa",
  "checkout-unlock-code-error-message": "El código de autorización del empleado es inválido.",
  "checkout-printing-now-title": "Imprimiendo ahora",
  "checkout-prints-ready-message": "Tus impresiones estarán listas en un minuto",
  "checkout-digitals-unlocked-message": "Tus fotos digitales ahora están desbloqueadas",
  "checkout-internal-error-title": "Lo sentimos, error interno",
  "checkout-transaction-processed-title": "¡TRANSACCIÓN PROCESADA!",
  "checkout-register-receipt-qr-message": "¡Escanea el código QR para registrar tu correo y recibir el recibo digital y el enlace al álbum!",
  "checkout-shop-more-btn": "Seguir comprando",
  "checkout-print-receipt-btn": "Imprimir recibo",
  "checkout-paid-by-cash-label": "Pagado en efectivo",
  "checkout-paid-by-card-label": "Pagado con tarjeta",
  "checkout-draft-order-error-message": "No se pudo crear el borrador del pedido.",
  "checkout-print-confirmation-message": "Si pediste impresiones, estarán listas en un minuto. Puedes recoger tu mercancía en el mostrador de venta",
  "checkout-shopify-params-incomplete-message": "Los parámetros de Shopify no están completos",
  "checkout-event-name-required-message": "No se proporcionó eventName.",
  "payment-no-device-connected-message": "No hay ningún dispositivo conectado.",
  "payment-ask-for-assistance-message": "Por favor solicita ayuda.",
  "payment-square-checkout-creation-failed-message": "La solicitud de checkout falló. Inténtalo de nuevo más tarde.",
  "payment-square-checkout-status-check-failed-message": "La verificación del estado del checkout falló. Inténtalo de nuevo más tarde.",
  "payment-qr-title": "Paga desde tu teléfono",
  "payment-qr-help-html": "<b>Rápido y fácil:</b><br> Escanea el código QR de arriba y sigue las instrucciones en pantalla.",
  "payment-qr-transaction-progress-message": "La transacción está en curso...",
  "payment-qr-failed-message": "El pago por QR falló. Verifica la clave API e inténtalo de nuevo.",
  "payment-failed-message": "El pago falló. Inténtalo de nuevo más tarde.",
  "payment-failed-short-message": "Tu pago falló.",
  "payment-use-pinpad-message": "Por favor usa el PinPad para completar tu transacción...",
  "payment-terminal-progress-message": "Transacción en progreso. <br>Para cancelar, toca la flecha en la terminal.",
  "payment-transaction-canceled-message": "Tu transacción ha sido cancelada.",
  "payment-transaction-canceled-close-btn": "Volver",
  "payment-transaction-canceled-done-btn": "Inicio",
  "search-version-label": "kiosk v.{{version}}",
  "search-find-by-qr-btn": "Buscar por QR",
  "search-find-by-face-btn": "Buscar por rostro",
  "search-scan-another-qr-placeholder": "Escanea otro código QR",
  "search-scanned-attendee-label": "Escaneado: {{attId}}",
  "search-qr-or-photos-not-found-message": "No se encontraron el código QR o las fotos. Escanea nuevamente.",
  "scanning-qr-page-title": "Álbum de fotos",
  "photo-viewer-back-btn": "Volver al álbum"
}
